/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
(window as any).global = window;

import 'hammerjs/hammer';
import 'zone.js';

import { ZEF } from '@shared/models/zef.model';
import { ZefThemePalette } from '@shared/models/color.model';

import { install } from 'resize-observer';

if (!window.ResizeObserver) install();

declare global {
  interface Window {
    ZEF?: ZEF;
    global: Window;
    HubSpotConversations: any;
    hsConversationsSettings: any;
    hsConversationsOnReady: any;
    $localize: {
      locale: string;
    };
  }
}

declare module '@angular/material/core' {
  interface CanColor {
    color: ZefThemePalette;
  }
}

/**
 * WORKAROUND — DEV-ONLY
 *
 * Chrome warns:
 *   “Unable to preventDefault inside passive event listener invocation”
 * whenever Angular CDK Drag-Drop calls `event.preventDefault()` on a
 * `mousemove` / `pointermove` event *after* another script has already
 * registered a **passive** listener for the same event (e.g. LogRocket,
 * Sentry Replay, PostHog, etc.).
 *
 * Because Zone.js re-uses the first listener’s options, CDK’s own listener
 * is marked passive and the call to `preventDefault()` (used to stop text
 * selection while dragging) triggers the warning.
 *
 * By attaching a no-op *active* listener **before** those third-party
 * recorders load, we force Zone.js to keep `passive:false` for subsequent
 * listeners, eliminating the warning with zero functional impact.
 *
 * Guarded behind `!production` because:
 *   • Replay/analytics scripts are disabled in prod builds.
 *   • The extra listener would be unnecessary overhead there.
 *
 * Remove this snippet once we no longer load a recorder that registers passive mouse listeners.
 */

document.addEventListener('mousemove', () => {}, { passive: false, capture: true });
